import { render } from "./CallRow.vue?vue&type=template&id=2b58323a&scoped=true"
import script from "./CallRow.vue?vue&type=script&lang=js"
export * from "./CallRow.vue?vue&type=script&lang=js"

import "./CallRow.vue?vue&type=style&index=0&id=2b58323a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b58323a"]])

export default __exports__